"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollOffMaterialPriceMatrixCreate = exports.RollOffMaterialPriceMatrix = exports.RollOffSizePriceMatrix = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
// was PricingSizeDataTransport
exports.RollOffSizePriceMatrix = typebox_1.Type.Object({
    dump: typebox_1.Type.Number(),
    over: typebox_1.Type.Number(),
    size: typebox_1.Type.String(),
    haul: typebox_1.Type.Number(),
    tonLimit: typebox_1.Type.Optional(typebox_1.Type.Number()),
    rentalPeriod: typebox_1.Type.Optional(common_1.Duration),
    allowOnlineCheckout: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
// was MaterialPricingTransport or PricingDataTransport
exports.RollOffMaterialPriceMatrix = typebox_1.Type.Object({
    // db columns
    id: typebox_1.Type.String(),
    pricingID: typebox_1.Type.String(),
    effectiveDate: typebox_1.Type.String(),
    expirationDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerApproved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    sourgumApproved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    // start need to be moved out of details into it's own column
    material: common_1.Material,
    doesNotService: typebox_1.Type.Boolean(),
    allowForLowerTonLimit: typebox_1.Type.Boolean(),
    allowOnlineCheckout: typebox_1.Type.Boolean(),
    tax: typebox_1.Type.Boolean(),
    type: common_1.RollOffPricingType, // ton, flat, yard needs to be validated
    sizes: typebox_1.Type.Array(exports.RollOffSizePriceMatrix),
    // end need to be moved out of details into it's own column
    customerDiscountApplied: typebox_1.Type.Optional(typebox_1.Type.Boolean()), // from wayste only
    discountCustomerID: typebox_1.Type.Optional(typebox_1.Type.String()), // from wayste only
    metadata: common_1.MetaData,
    // lastUpdatedAt: Type.String(), // metadata lastUpdateAt should be updated to reflect this or older rows
});
exports.RollOffMaterialPriceMatrixCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RollOffMaterialPriceMatrix, [
        'id',
        'metadata',
        'haulerApproved',
        'sourgumApproved',
        'pricingID',
        'expirationDate',
        'customerDiscountApplied',
        'discountCustomerID',
    ]),
]);
//# sourceMappingURL=roll-off-material-price-matrix.js.map